/**
 * Read user/org context for Sentry events without importing from core/.
 * Reads from localStorage where userProfileSlice persists the session.
 * Safe to call from any layer (shared, core, features).
 */
import { getStorageItem, STORAGE_KEYS } from '@/core/utils/local-storage';

export function getSentryUserContext(): { userId: string | null; organizationId: string | null } {
  try {
    const session = getStorageItem(STORAGE_KEYS.USER_PROFILE_SESSION) as { id?: string | null; organizationId?: string | null } | null;
    if (!session) return { userId: null, organizationId: null };
    return {
      userId: session.id ? String(session.id) : null,
      organizationId: session.organizationId ? String(session.organizationId) : null,
    };
  } catch {
    return { userId: null, organizationId: null };
  }
}
